export const WEATHER_STATION_MODELS = [
  "SenseCAP_S2100_Weather_Station_S700_C",
];

export const WEATHER_STATION_TYPE_IDS = [
  "99e43c1d-2ceb-4eef-9f36-fc4d635c61ca",
];

export const WEATHER_MEASURES = {
  air_temperature: { label: "Temperatura dell’aria", unit: "°C", aliases: ["temperature"] },
  air_humidity: { label: "Umidità dell’aria", unit: "%" },
  pressure: { label: "Pressione atmosferica", unit: "Pa" },
  wind_direction: { label: "Direzione media del vento", unit: "°" },
  wind_speed: { label: "Velocità media del vento", unit: "m/s" },
  rain_intensity: { label: "Intensità della pioggia", unit: "mm/h" },
  global_solar_radiation: {
    label: "Radiazione solare globale",
    unit: "W/m²",
    aliases: ["solar_radiation"],
  },
  sunshine_duration: { label: "Durata del soleggiamento", unit: "h" },
};

export const SENSOR_MEASURES = {
  soil_temperature: { label: "Temperatura", unit: "°C", apiKey: "temperature" },
  soil_moisture: { label: "Umidità", unit: "%", apiKey: "moisture" },
  soil_electrical_conductivity: {
    label: "Conducibilità Elettrica",
    unit: "µS/cm",
    apiKey: "soil_ec",
  },
  air_temperature: { label: "Temperatura", unit: "°C" },
  air_humidity: { label: "Umidità", unit: "%" },
  illuminance: { label: "Luminosità", unit: "lux" },
};

export const isWeatherStation = (sensor) => {
  const sensorType = sensor?.sensor_type || sensor?.sensorType || sensor;
  const sensorTypeId =
    typeof sensorType === "object" ? sensorType?.id : sensorType;

  return (
    WEATHER_STATION_MODELS.includes(sensorType?.model) ||
    WEATHER_STATION_TYPE_IDS.includes(sensorTypeId)
  );
};

export const getMeasureDefinition = (parameter, sensor) => {
  const weatherStation = isWeatherStation(sensor);
  const preferredDefinitions = weatherStation
    ? WEATHER_MEASURES
    : SENSOR_MEASURES;
  const fallbackDefinitions = weatherStation
    ? SENSOR_MEASURES
    : WEATHER_MEASURES;
  const findDefinition = (definitions) =>
    definitions[parameter] ||
    Object.values(definitions).find(
      (definition) =>
        definition.apiKey === parameter ||
        definition.aliases?.includes(parameter),
    );
  const definition =
    findDefinition(preferredDefinitions) ||
    findDefinition(fallbackDefinitions);

  return { apiKey: parameter, label: parameter, unit: "", ...definition };
};

export const filterSensorsByField = (sensors, fieldId, fieldSensors = []) => {
  const sensorIds = new Set(
    (Array.isArray(fieldSensors) ? fieldSensors : []).map((sensor) =>
      String(sensor?.id || sensor),
    ),
  );

  return (Array.isArray(sensors) ? sensors : []).filter((sensor) => {
    const assignedField = sensor?.assigned_field || sensor?.field;
    const assignedFieldId = assignedField?.id || assignedField;

    if (assignedFieldId !== undefined && assignedFieldId !== null) {
      return String(assignedFieldId) === String(fieldId);
    }

    return sensorIds.has(String(sensor?.id));
  });
};

export const getMeasureUnit = (measure) => {
  const definition =
    SENSOR_MEASURES[measure] ||
    WEATHER_MEASURES[measure] ||
    Object.values(SENSOR_MEASURES).find((item) => item.apiKey === measure) ||
    Object.values(WEATHER_MEASURES).find((item) =>
      item.aliases?.includes(measure),
    );
  return definition?.unit || "";
};

export const getMeasurePayloadKeys = (measure) => {
  const definition = getMeasureDefinition(measure);
  return Array.from(
    new Set([definition.apiKey, measure, ...(definition.aliases || [])]),
  );
};

export const getSharedMeasures = (sensors, otherSensors) => {
  const otherKeys = new Set(
    (otherSensors || []).flatMap((sensor) =>
      (sensor?.sensor_type?.measured_parameters || []).flatMap(getMeasurePayloadKeys),
    ),
  );
  return Array.from(
    new Set(
      (sensors || []).flatMap((sensor) =>
        (sensor?.sensor_type?.measured_parameters || []).filter((measure) =>
          getMeasurePayloadKeys(measure).some((key) => otherKeys.has(key)),
        ),
      ),
    ),
  );
};
